import { isBrowser } from '../../lib/platform';
/**
 * @description 获取当前服务器时间
 * @returns 返回Date对象
 */
export function getServerDate() {
    return new Promise((resolve) => {
        try {
            // 判断是否为node环境
            if (!isBrowser) {
                // node环境，一般为SSR环境，本地时间可信，直接使用 
                resolve(new Date());
            }
            else {
                // 浏览器环境，发一个请求获取服务器时间
                const xhr = new XMLHttpRequest();
                const now = new Date();
                xhr.open('HEAD', window.location.href, true);
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 2 || xhr.readyState === 4) {
                        const dateStr = xhr.getResponseHeader("Date");
                        const date = dateStr ? new Date(dateStr) : now;
                        resolve(date);
                    }
                };
                xhr.send(null);
            }
        }
        catch (e) {
            resolve(new Date());
        }
    });
}
export default getServerDate;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvZ2V0U2VydmVyRGF0ZS9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sb0JBQW9CLENBQUM7QUFDL0M7OztHQUdHO0FBQ0gsTUFBTSxVQUFVLGFBQWE7SUFDM0IsT0FBTyxJQUFJLE9BQU8sQ0FBTyxDQUFDLE9BQU8sRUFBRSxFQUFFO1FBQ25DLElBQUk7WUFDRixjQUFjO1lBQ2QsSUFBSSxDQUFDLFNBQVMsRUFBRTtnQkFDZCwrQkFBK0I7Z0JBQy9CLE9BQU8sQ0FBQyxJQUFJLElBQUksRUFBRSxDQUFDLENBQUM7YUFDckI7aUJBQU07Z0JBQ0wscUJBQXFCO2dCQUNyQixNQUFNLEdBQUcsR0FBRyxJQUFJLGNBQWMsRUFBRSxDQUFDO2dCQUNqQyxNQUFNLEdBQUcsR0FBRyxJQUFJLElBQUksRUFBRSxDQUFDO2dCQUN2QixHQUFHLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRSxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQTtnQkFDNUMsR0FBRyxDQUFDLGtCQUFrQixHQUFHO29CQUN2QixJQUFJLEdBQUcsQ0FBQyxVQUFVLEtBQUssQ0FBQyxJQUFJLEdBQUcsQ0FBQyxVQUFVLEtBQUssQ0FBQyxFQUFFO3dCQUNoRCxNQUFNLE9BQU8sR0FBRyxHQUFHLENBQUMsaUJBQWlCLENBQUMsTUFBTSxDQUFDLENBQUM7d0JBQzlDLE1BQU0sSUFBSSxHQUFHLE9BQU8sQ0FBQyxDQUFDLENBQUMsSUFBSSxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQzt3QkFDL0MsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFBO3FCQUNkO2dCQUNILENBQUMsQ0FBQztnQkFDRixHQUFHLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO2FBQ2hCO1NBQ0Y7UUFBQyxPQUFPLENBQUMsRUFBRTtZQUNWLE9BQU8sQ0FBQyxJQUFJLElBQUksRUFBRSxDQUFDLENBQUE7U0FDcEI7SUFDSCxDQUFDLENBQUMsQ0FBQTtBQUNKLENBQUM7QUFFRCxlQUFlLGFBQWEsQ0FBQyJ9